import type { FC, ReactNode } from 'react'
import type { PostCard as PostCardType } from '@/types'

import { Container } from '@/components/generals/container'
import { SectionHeading } from '@/components/generals/section-heading'
import { PostCard } from '@/components/content/post-card'
import { FeaturedArticle } from '@/components/home/featured-article'

interface HomeLatestProps {
    feature: PostCardType | null
    posts: PostCardType[]
}

export const HomeLatest: FC<HomeLatestProps> = ({ feature, posts }): ReactNode => {
    return (
        <section id='journal' className='scroll-mt-20 bg-secondary/40'>
            <Container className='py-16 sm:py-20'>
                <SectionHeading
                    eyebrow='From the journal'
                    title='Fresh thinking on everyday wellness'
                    description='New, evidence-aware articles across holistic health, lifestyle balance, and mind & body.'
                />

                {feature && (
                    <div className='mt-10'>
                        <FeaturedArticle post={feature} />
                    </div>
                )}

                {posts.length > 0 && (
                    <div className='mt-12 grid grid-cols-1 gap-x-8 gap-y-12 sm:grid-cols-2 lg:grid-cols-3'>
                        {posts.map((post) => (
                            <PostCard key={post.id} post={post} />
                        ))}
                    </div>
                )}
            </Container>
        </section>
    )
}
